/*
 * The HR portal, for company contacts. It has its own shell and never
 * renders the firm app's sidebar.
 *
 *   /company           Employees (Needs you, requests, the employee table)
 *   /company/request   Request a case
 *   /company/spend     Spend against budget
 *   /company/sign-in   Email link sign-in
 */
export const PORTAL_PATH = "/company";
export const PORTAL_REQUEST_PATH = "/company/request";
export const PORTAL_SPEND_PATH = "/company/spend";
export const PORTAL_SIGN_IN_PATH = "/company/sign-in";

export const PORTAL_EMAIL_KEY = "companyPortalEmail";
